<div class="container">
  <div class="page-header">
    <div class="page-header-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-1 .1-1.3.5l-.7.9c-.4.4-.2 1.1.3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.4 5.9c.2.5.9.7 1.3.3l.9-.7c.4-.3.6-.8.5-1.3z"/>
      </svg>
    </div>
    <div class="page-header-textos">
      <h1>Lista de Aeronaves</h1>
      <p>Aeronaves cadastradas — duplo clique para editar</p>
    </div>
    <button type="button" class="btn primary" (click)="onNovo()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Cadastrar
    </button>
    <div class="header-funcoes" (click)="$event.stopPropagation()">
      <button type="button" class="btn-config" (click)="toggleFuncoesMenu($event)" title="Funções">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      </button>
      <div class="pcf-funcoes-menu" *ngIf="funcoesMenuAberto">
        <button type="button" class="pcf-funcoes-item" (click)="abrirComparacao()">Comparar com o Aerosys</button>
      </div>
    </div>
  </div>


  <!-- Função: Comparar com o Aerosys -->
  <div class="vca-overlay" *ngIf="cmpAberto" (click)="fecharComparacao()">
    <div class="vca-box" (click)="$event.stopPropagation()">
      <div class="vca-header">
        <div>
          <strong>Comparar Aeronaves com o Aerosys</strong>
          <span>Compara pela matrícula (prefixo): mostra o que existe no Aerosys e não no Sankhya, e as diferenças de modelo, fabricante, nº de série, ano e proprietário nas que já existem.</span>
        </div>
        <button type="button" class="vca-fechar" (click)="fecharComparacao()" title="Fechar" [disabled]="cmpImportando">×</button>
      </div>

      <div class="lista-carregando" *ngIf="cmpCarregando">
        <app-loading-indicator size="inline"></app-loading-indicator>
        <span>Consultando o Aerosys e comparando...</span>
      </div>

      <div class="vca-erro" *ngIf="cmpErro">{{ cmpErro }}</div>

      <ng-container *ngIf="!cmpCarregando && cmpLinhas.length">
        <div class="vca-resumo">
          <span class="vca-chip nao">Não existem no Sankhya: {{ cmpContar('FALTA') }}</span>
          <span class="vca-chip inc">Com diferenças: {{ cmpContar('DIFERENTE') }}</span>
          <span class="vca-chip ok">Em ordem: {{ cmpContar('OK') }}</span>
        </div>

        <div class="vca-filtros">
          <select [(ngModel)]="cmpFiltro" (ngModelChange)="cmpLimite = 100" aria-label="Filtrar">
            <option value="FALTAM">Não existem no Sankhya</option>
            <option value="DIFERENCAS">Com diferenças</option>
            <option value="EM_ORDEM">Em ordem</option>
            <option value="TODOS">Todas</option>
          </select>
          <input type="text" [(ngModel)]="cmpBusca" (ngModelChange)="cmpLimite = 100" placeholder="Filtrar por código, matrícula, modelo, fabricante, série ou proprietário...">
          <span class="vca-contagem">{{ cmpFiltrados.length }} registro(s)</span>
        </div>

        <div class="vca-geral" *ngIf="cmpFiltro === 'FALTAM'">
          <button type="button" class="btn secondary" (click)="cmpMarcarTodos(true)" [disabled]="cmpImportando">Marcar todas</button>
          <button type="button" class="btn secondary" (click)="cmpMarcarTodos(false)" [disabled]="cmpImportando">Desmarcar</button>
          <button type="button" class="btn vca-corrigir" (click)="importarSelecionadas()" [disabled]="cmpImportando || !cmpSelecionados.length">
            {{ cmpImportando ? 'Importando...' : 'Importar selecionadas para o Sankhya (' + cmpSelecionados.length + ')' }}
          </button>
        </div>

        <div class="vca-erro" *ngFor="let m of cmpResultadoImport">{{ m }}</div>

        <div class="vca-tabela">
          <table class="tabela">
            <thead>
              <tr>
                <th></th>
                <th>Situação</th>
                <th>Código (Aerosys)</th>
                <th>Matrícula</th>
                <th>Modelo</th>
                <th>Fabricante</th>
                <th>Proprietário (Aerosys)</th>
                <th>Diferenças</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let l of cmpFiltrados | slice:0:cmpLimite">
                <td>
                  <input type="checkbox" *ngIf="l.situacao === 'FALTA'" [(ngModel)]="l.marcado" [disabled]="cmpImportando">
                </td>
                <td><span class="vca-sit" [ngClass]="l.situacao === 'FALTA' ? 'NAO_CADASTRADO' : (l.situacao === 'DIFERENTE' ? 'INCOMPLETO' : '')">{{ cmpRotulo(l.situacao) }}</span></td>
                <td>{{ ('' + l.aerId).padStart(7, '0') }}</td>
                <td>{{ l.matricula }}</td>
                <td>{{ l.modelo || '—' }}</td>
                <td>{{ l.fabricante || '—' }}</td>
                <td>{{ l.proprietario || '—' }}</td>
                <td>
                  <ul *ngIf="l.diferencas.length" style="margin:0;padding-left:16px;font-size:12px;">
                    <li *ngFor="let d of l.diferencas">{{ d }}</li>
                  </ul>
                  <span *ngIf="!l.diferencas.length">—</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="vca-mais" *ngIf="cmpFiltrados.length > cmpLimite">
            <button type="button" class="btn secondary" (click)="cmpLimite = cmpLimite + 100">Mostrar mais 100 (de {{ cmpFiltrados.length }})</button>
          </div>
        </div>
      </ng-container>

      <div class="lista-vazia" *ngIf="!cmpCarregando && !cmpErro && !cmpLinhas.length">Nenhuma aeronave encontrada no Aerosys.</div>

      <div class="vca-rodape">
        <button type="button" class="btn secondary" (click)="compararComAerosys()" [disabled]="cmpCarregando || cmpImportando">Comparar novamente</button>
        <button type="button" class="btn secondary" (click)="fecharComparacao()" [disabled]="cmpImportando">Fechar</button>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="lista-toolbar">
      <div class="field field-wide">
        <input type="text" [(ngModel)]="termoBusca" (ngModelChange)="onBuscaChange()"
          aria-label="Pesquisar na lista de aeronaves"
          placeholder="Pesquisar por prefixo, modelo, fabricante, nº de série ou proprietário...">
      </div>
      <button type="button" class="btn secondary" (click)="carregar()" [disabled]="carregando"
        title="Recarregar a lista de aeronaves">
        Atualizar
      </button>
    </div>

    <div class="lista-carregando" *ngIf="carregando">
      <app-loading-indicator size="inline"></app-loading-indicator>
      <span>Carregando aeronaves...</span>
    </div>

    <div class="lista-erro" *ngIf="erro && !carregando">{{ erro }}</div>

    <ng-container *ngIf="!carregando && !erro">
      <div class="lista-vazia" *ngIf="!filtradas.length">Nenhuma aeronave encontrada.</div>

      <div class="tabela-card" *ngIf="filtradas.length">
        <table class="tabela">
          <thead>
            <tr>
              <th>Código</th>
              <th>Tipo</th>
              <th>Modelo</th>
              <th>Fabricante</th>
              <th>Matrícula (Prefixo)</th>
              <th>Nº de Série</th>
              <th>Ano Fab.</th>
              <th>Proprietário</th>
              <th>Tipo de Vínculo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let a of pagina; trackBy: trackAero" (click)="linhaSelecionada = a" (dblclick)="onEditar(a)"
                title="Duplo clique para editar" [class.linha-selecionada]="linhaSelecionada === a">
              <td>{{ codigo(a) }}</td>
              <td>{{ a.tipo ? (a.tipo | uppercase) : '—' }}</td>
              <td>{{ a.modelo || '—' }}</td>
              <td>{{ a.fabricante || '—' }}</td>
              <td>{{ a.prefixo || '—' }}</td>
              <td>{{ a.numSerie || '—' }}</td>
              <td>{{ a.anoFab || '—' }}</td>
              <td>{{ a.proprietario || '—' }}</td>
              <td>{{ a.vinculo || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lista-paginacao" *ngIf="filtradas.length">
        <div class="paginacao-info">
          {{ filtradas.length }} aeronave(s) — página {{ paginaAtual }} de {{ totalPaginas }}
        </div>
        <div class="paginacao-controles">
          <button type="button" class="btn-pag" (click)="irParaPagina(1)"
            [disabled]="paginaAtual === 1" title="Primeira página">«</button>
          <button type="button" class="btn-pag" (click)="irParaPagina(paginaAtual - 1)"
            [disabled]="paginaAtual === 1" title="Página anterior">‹</button>
          <button type="button" class="btn-pag ativo">{{ paginaAtual }}</button>
          <button type="button" class="btn-pag" (click)="irParaPagina(paginaAtual + 1)"
            [disabled]="paginaAtual === totalPaginas" title="Próxima página">›</button>
          <button type="button" class="btn-pag" (click)="irParaPagina(totalPaginas)"
            [disabled]="paginaAtual === totalPaginas" title="Última página">»</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
